import { call, put } from 'redux-saga/effects';
import { onGetVehicleMetaDataFailure, onGetVehicleMetaDataSuccess } from '../actions';
import { VehicleMetaDataService } from '../services';
export function* getVehicleMetaDataSaga(action, 
/*istanbul ignore next*/
vehicleMetaDataService = VehicleMetaDataService.getInstance()) {
    try {
        const result = yield call({
            fn: vehicleMetaDataService.getVehicleMetaData,
            context: vehicleMetaDataService
        }, action.payload.vehicle, action.payload.language);
        yield put(onGetVehicleMetaDataSuccess(result));
    }
    catch (exception) {
        yield put(onGetVehicleMetaDataFailure(exception.toString()));
    }
}
//# sourceMappingURL=getVehicleMetaDataSaga.js.map